import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { cn } from "@/lib/utils";
import { Monitor, WifiOff, MapPin } from "lucide-react";
import { ScrollArea } from "../ui/scroll-area";

interface Device {
  id: string;
  name: string;
  status: 'online' | 'offline';
  location: string;
  lastSeen: string;
}

interface DeviceStatusCardProps {
  devices: Device[];
  className?: string;
}

export function DeviceStatusCard({ devices, className }: DeviceStatusCardProps) {
  const onlineCount = devices.filter(d => d.status === 'online').length;
  const offlineCount = devices.length - onlineCount;

  return (
    <Card className={cn("col-span-full lg:col-span-3", className)}>
      <CardHeader>
        <CardTitle className="text-xl font-bold">Cihaz Durumu</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid grid-cols-2 gap-4">
          <div className="flex items-center gap-3 p-4 rounded-lg bg-muted/50">
            <div className="h-10 w-10 rounded-full bg-green-500/20 flex items-center justify-center">
              <Monitor className="h-5 w-5 text-green-500" />
            </div>
            <div>
              <p className="text-2xl font-bold">{onlineCount}</p>
              <p className="text-sm text-muted-foreground">Online Cihaz</p>
            </div>
          </div>

          <div className="flex items-center gap-3 p-4 rounded-lg bg-muted/50">
            <div className="h-10 w-10 rounded-full bg-red-500/20 flex items-center justify-center">
              <WifiOff className="h-5 w-5 text-red-500" />
            </div>
            <div>
              <p className="text-2xl font-bold">{offlineCount}</p>
              <p className="text-sm text-muted-foreground">Offline Cihaz</p>
            </div>
          </div>
        </div>

        <div>
          <h3 className="font-semibold mb-3">Cihaz Listesi</h3>
          <ScrollArea className="h-[300px]">
            <div className="space-y-4">
              {devices.map((device) => (
                <div
                  key={device.id}
                  className="p-3 rounded-lg border border-border hover:bg-muted/50 transition-colors"
                >
                  <div className="flex items-center justify-between mb-2">
                    <p className="font-medium">{device.name}</p>
                    <div className={cn(
                      "px-2 py-0.5 rounded-full text-xs",
                      device.status === 'online'
                        ? "bg-green-500/20 text-green-600"
                        : "bg-red-500/20 text-red-600"
                    )}>
                      {device.status}
                    </div>
                  </div>
                  <div className="flex items-center gap-4 text-sm text-muted-foreground">
                    <div className="flex items-center gap-1">
                      <MapPin className="h-3 w-3" />
                      {device.location}
                    </div>
                    <div>Son görülme: {device.lastSeen}</div>
                  </div>
                </div>
              ))}
            </div>
          </ScrollArea>
        </div>
      </CardContent>
    </Card>
  );
}
